import * as React from 'react';
import abbreviateNumber from 'utils/shared/number/abbreviateNumber';
// import calculatePercentOtm from 'utils/shared/trades/calculatePercentOtm';
import {
  TableWrapper,
  TableCell,
  TableHeader,
  HeaderCell,
  HeaderCellWrapper,
} from 'components/Table';
import calculateTickerOverview from 'utils/shared/trades/calculateTickerOverview';
import { calculateDirectionalFlowValue } from 'utils/shared/trades/aggregateOptionFlow';
import { OverviewProps } from './props';

import { OverviewRow, SingleRowBody } from './styles';

const TITLE_NAMES = [
  'Num Trades',
  'Momentum',
  'Avg Expiry',
  'OTM',
  'Total Contracts',
  'Total Premium',
  'Unusual OTM',
  'Unusual Contracts',
  'Unusual Premium',
  'Sweep OTM',
  'Sweep Contracts',
  'Sweep Premium',
];
const cols = TITLE_NAMES.length - 1;

const TickerOverviewTable: React.FC<React.PropsWithChildren<OverviewProps>> = ({
  trades,
  sweepTrades,
  unusualTrades,
  dailyVolume,
  metricMode = 'total',
}) => {
  const isNetMode = metricMode === 'net';
  const { otm, expiry, contracts, premium, momentum } = calculateTickerOverview(
    trades,
    dailyVolume,
  );
  const {
    otm: unusualOtm,
    contracts: unusualContracts,
    premium: unusualPremium,
  } = calculateTickerOverview(unusualTrades, dailyVolume);
  const {
    otm: sweepOtm,
    contracts: sweepContracts,
    premium: sweepPremium,
  } = calculateTickerOverview(sweepTrades, dailyVolume);
  const directionalPremium = calculateDirectionalFlowValue(
    trades || [],
    (trade) => trade.premium || 0,
  );
  const directionalContracts = calculateDirectionalFlowValue(
    trades || [],
    (trade) => trade.size || 0,
  );
  const directionalUnusualPremium = calculateDirectionalFlowValue(
    unusualTrades || [],
    (trade) => trade.premium || 0,
  );
  const directionalUnusualContracts = calculateDirectionalFlowValue(
    unusualTrades || [],
    (trade) => trade.size || 0,
  );
  const directionalSweepPremium = calculateDirectionalFlowValue(
    sweepTrades || [],
    (trade) => trade.premium || 0,
  );
  const directionalSweepContracts = calculateDirectionalFlowValue(
    sweepTrades || [],
    (trade) => trade.size || 0,
  );
  const titles = isNetMode
    ? TITLE_NAMES.map((title) =>
        title
          .replace('Total Contracts', 'Net Contracts')
          .replace('Total Premium', 'Net Premium')
          .replace('Unusual Contracts', 'Net Unusual Contracts')
          .replace('Unusual Premium', 'Net Unusual Premium')
          .replace('Sweep Contracts', 'Net Sweep Contracts')
          .replace('Sweep Premium', 'Net Sweep Premium'),
      )
    : TITLE_NAMES;

  return (
    <TableWrapper>
      <TableHeader>
        <OverviewRow removePad>
          {titles.map((t, i) => (
            <HeaderCellWrapper
              key={i}
              removePad={i + 1 === titles.length}
              isUnusual={i >= cols - 5 && i < cols - 2}
              isSweep={i >= cols - 2}
            >
              <HeaderCell>{t}</HeaderCell>
            </HeaderCellWrapper>
          ))}
        </OverviewRow>
      </TableHeader>
      <SingleRowBody className="flex-shrink overflow-auto px-4 py-2">
        <OverviewRow className="h-full items-center">
          {/* <TableCell>{activeTicker}</TableCell> */}
          <TableCell>{(trades || []).length}</TableCell>
          <TableCell>{momentum.toFixed(1)}x</TableCell>
          <TableCell>{Math.round(expiry)} days</TableCell>
          <TableCell>{Math.round(otm)}%</TableCell>
          <TableCell>
            {abbreviateNumber(isNetMode ? directionalContracts.net : contracts)}
          </TableCell>
          <TableCell>${abbreviateNumber(isNetMode ? directionalPremium.net : premium)}</TableCell>
          <TableCell>{Math.round(unusualOtm)}%</TableCell>
          <TableCell>
            {abbreviateNumber(isNetMode ? directionalUnusualContracts.net : unusualContracts)}
          </TableCell>
          <TableCell>
            ${abbreviateNumber(isNetMode ? directionalUnusualPremium.net : unusualPremium)}
          </TableCell>
          <TableCell>{Math.round(sweepOtm)}%</TableCell>
          <TableCell>
            {abbreviateNumber(isNetMode ? directionalSweepContracts.net : sweepContracts)}
          </TableCell>
          <TableCell>
            ${abbreviateNumber(isNetMode ? directionalSweepPremium.net : sweepPremium)}
          </TableCell>
        </OverviewRow>
      </SingleRowBody>
    </TableWrapper>
  );
};

export default TickerOverviewTable;
